import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { UnitcodeResponseModel, AllUnitcodeResponseModel, PlantsDropDown, UnitTypeEnum, PlantsDropDownResponse, UnitcodeDto, PlantIdRequest } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { UnitcodeAdapter } from './dto/unit-codes.adapter';
import { UnitCodeDTO } from './dto/unit-codes.dto';
import { UnitcodeRequest } from './dto/unit-code.request'
import { UnitCodes } from './unit-codes.entity';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';

@Injectable()
export class UnitCodesService {

  constructor(
    private logService:LogsService,
    @InjectRepository(UnitCodes)
    private unitcodesRepository: Repository<UnitCodes>,
    private unitcodesAdapter: UnitcodeAdapter,
  ) { }

  async getUnitcodesWithoutRelations(unitcodeName: string):
    Promise<UnitCodes> {
    const UnitcodeResponse = await this.unitcodesRepository.findOne({
      where: { unitcodeName: Raw(alias => `unit_name = '${unitcodeName}'`) },
    });
    if (UnitcodeResponse) {
      return UnitcodeResponse;
    }
    else {
      return null;
    }
  }


  async createUnitcode(unitcodeDTO: UnitCodeDTO, isUpdate: boolean): Promise<UnitcodeResponseModel> {
    try {
      let previousValue;
  
      if (isUpdate) {
        const previous = await this.unitcodesRepository.findOne({ where: { unitcodeId: unitcodeDTO.unitcodeId } });
        if (previous) {
          previousValue = `${previous.unitcodeName}, ${previous.plantType}`;
        }
      } else {
        const unitcodeEntity = await this.unitcodesRepository.findOne({ where: { unitcodeName: unitcodeDTO.unitcodeName } });
        if (unitcodeEntity) {
          throw new UnitcodeResponseModel(false, 11104, 'Unitcode already exists');
        }
      }
  
      // Ensure `unitcodeDTO.company` is a string and valid JSON
      let selectedCompany;
      try {
        selectedCompany = JSON.parse(unitcodeDTO.company as string);
      } catch (error) {
        throw new UnitcodeResponseModel(false, 11108, 'Invalid company data format');
      }
  
      const convertedUnitcodeEntity: UnitCodes = this.unitcodesAdapter.convertDtoToEntity(unitcodeDTO, isUpdate);
  
      // Assign the parsed company data to the entity
      convertedUnitcodeEntity.company = selectedCompany.name;
      convertedUnitcodeEntity.companyId = selectedCompany.value;
  
      const savedUnitcodeEntity: UnitCodes = await this.unitcodesRepository.save(convertedUnitcodeEntity);
      const savedUnitcodesDto: UnitCodeDTO = this.unitcodesAdapter.convertEntityToDto(savedUnitcodeEntity);
  
      if (savedUnitcodesDto) {
        const present = `${savedUnitcodesDto.unitcodeName}, ${savedUnitcodesDto.plantType}`;
        const displayValue = isUpdate ? 'Unitcode Updated Successfully' : 'Unitcode Created Successfully';
        const name = isUpdate ? 'updated' : 'created';
        const userName = isUpdate ? savedUnitcodesDto.updatedUser : savedUnitcodesDto.createdUser;
  
        const newLogDto = new LogsDto(1, name, 'UnitCodes', savedUnitcodesDto.unitcodeId, true, displayValue, userName, previousValue, present);
        const res = await this.logService.createLog(newLogDto);
        console.log(res);
  
        return new UnitcodeResponseModel(true, 1, displayValue);
      } else {
        throw new UnitcodeResponseModel(false, 11106, 'Unitcode saved but issue while transforming into DTO');
      }
    } catch (error) {
      console.error(error);
      return new UnitcodeResponseModel(false, 11107, `Error occurred: ${error.message}`);
    }
  }
  



  async getAllUnitcodes(req?:UserRequestDto): Promise<AllUnitcodeResponseModel> {
    // const page: number = 1;
    // const response = new AllDestinationsResponseModel();
    try {
      const unitcodeDTO: UnitCodeDTO[] = [];
      //retrieves all companies
      const UnitcodeEntity: UnitCodes[] = await this.unitcodesRepository.find({ order: { unitcodeName: 'ASC' } });
      //console.log(statesEntities);
      if (UnitcodeEntity) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        UnitcodeEntity.forEach(UnitcodeEntity => {
          const convertedUnitcodeDto: UnitCodeDTO = this.unitcodesAdapter.convertEntityToDto(
            UnitcodeEntity
          );
          unitcodeDTO.push(convertedUnitcodeDto);
        });

        //generated response

        const response = new AllUnitcodeResponseModel(true, 1, 'UnitCodes retrieved successfully', unitcodeDTO);
        if(req?.createdUser){
          const newLogDto = new LogsDto(0,'view', 'UnitCodes', 0, true, 'UnitCodes retrieved successfully',req.createdUser,'','')
        let res = await this.logService.createLog(newLogDto);
        console.log(res);
        }
        return response;
      } else {
        throw new UnitcodeResponseModel(false, 99998, 'Data not found');
      }
      // return response;
    } catch (err) {
      return err;
    }
  }
  async getAllActiveUnitcodes(): Promise<AllUnitcodeResponseModel> {
    // const page: number = 1;
    try {
      const unitcodeDTO: UnitCodeDTO[] = [];
      //retrieves all companies
      const UnitcodeEntity: UnitCodes[] = await this.unitcodesRepository.find({
        where: { plantType: UnitTypeEnum.PLANT },
        order: { unitcodeName: 'ASC' },
      });
      if (UnitcodeEntity) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        UnitcodeEntity.forEach(UnitcodeEntity => {
          const convertedUnitcodeDto: UnitCodeDTO = this.unitcodesAdapter.convertEntityToDto(
            UnitcodeEntity
          );
          unitcodeDTO.push(convertedUnitcodeDto);
        });
        const response = new AllUnitcodeResponseModel(true, 11108, "Unitcodes retrieved successfully", unitcodeDTO);
        return response;
      } else {
        throw new UnitcodeResponseModel(false, 99998, 'Data not found'); unitcodeDTO
      }
    } catch (err) {
      return err;
    }
  }

  async getPlantDetailsById(unitcodeReq: PlantIdRequest): Promise<UnitcodeResponseModel> {
    try {
      const plantDetails = await this.unitcodesRepository.findOne({ unitcodeId: unitcodeReq.unitcodeId });
      if (plantDetails) {
        const data = new UnitcodeDto(plantDetails.unitcodeId, plantDetails.unitcodeName, plantDetails.plantType, plantDetails.isActive, plantDetails.createdUser, plantDetails.villageName, plantDetails.mandalName, plantDetails.distirctName, plantDetails.stateName, plantDetails.countryName, plantDetails.fdaRegNumber, plantDetails.feiNumber, plantDetails.shortKey, plantDetails.postalCode, plantDetails.plantCode, plantDetails.bapNo,plantDetails.approvalNo,plantDetails.ascNo,plantDetails.walmartId,plantDetails.fishInapprovalNo,plantDetails.krogerNo,plantDetails.updatedUser,plantDetails.company,plantDetails.companyId);

        const response = new UnitcodeResponseModel(true, 1001, "Plant Details retrived successfully", data);
        return response
      }
      else {
        const response = new UnitcodeResponseModel(false, 1010, "Plant Details retrived successfully",);
        return response
      }
    }
    catch (err) {
      return err;
    }
  }
  async activateOrDeactivateUnitcode(unitcodeReq: UnitcodeRequest): Promise<UnitcodeResponseModel> {
    try {
      const unitcodeExists = await this.getUnitcodeById(unitcodeReq.unitcodeId);
      if (unitcodeExists) {
        if (unitcodeReq.versionFlag !== unitcodeExists.versionFlag) {
          throw new UnitcodeResponseModel(false, 10113, 'Someone updated the information.Refresh and try again');
        } else {

          const unitcodeStatus = await this.unitcodesRepository.update(
            { unitcodeId: unitcodeReq.unitcodeId },
            { isActive: unitcodeReq.isActive, updatedUser: unitcodeReq.updatedUser });

          if (unitcodeExists.isActive) {
            if (unitcodeStatus.affected) {
              const unitcodeResponse: UnitcodeResponseModel = new UnitcodeResponseModel(true, 10115, 'de-activated successfully');
              return unitcodeResponse;
            } else {
              throw new UnitcodeResponseModel(false, 10111, 'already deactivated');
            }
          } else {
            if (unitcodeStatus.affected) {
              const unitcodeResponse: UnitcodeResponseModel = new UnitcodeResponseModel(true, 10114, 'activated successfully');
              return unitcodeResponse;
            } else {
              throw new UnitcodeResponseModel(false, 10112, 'already  activated');
            }
          }
          // }
        }
      } else {
        throw new UnitcodeResponseModel(false, 99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }

  async getUnitcodeById(unitcodeId: number): Promise<UnitCodes> {
    //  console.log(employeeId);
    const Response = await this.unitcodesRepository.findOne({
      where: { unitcodeId: unitcodeId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async getAllMainPlants(): Promise<PlantsDropDownResponse> {
    try {
      const unitEntities: PlantsDropDown[] = await this.unitcodesRepository.createQueryBuilder()
        .select('unit_code_id as plantId, unit_name as plantName,company,plant_code as plantCode')
        .where(`plant_type='${UnitTypeEnum.PLANT}' and is_active=1 and unit_name!='Head Office'`)
        .orderBy('unit_name')
        .getRawMany();

      if (unitEntities && unitEntities.length) {
        const resu = new PlantsDropDownResponse(true, 1111, 'Plants Retrieved Successfully', unitEntities);
        // const newLogDto = new LogsDto(1,'view all plants', 'UnitCodes', 0, true, '','','','')
        //     let res = await this.logService.createLog(newLogDto);
        //     console.log(res);
        return resu
      }
    } catch (error) {
      return error
    }

  }

  async getAllMainAndSubContractPlants(): Promise<PlantsDropDownResponse> {
    try {
      const unitEntities: PlantsDropDown[] = await this.unitcodesRepository.createQueryBuilder()
        .select('unit_code_id as plantId, unit_name as plantName')
        .where(`plant_type in ('${UnitTypeEnum.PLANT}','${UnitTypeEnum.SUB_CONTRACTOR_PLANT}') and is_active=1 and unit_name!='Head Office'`)
        .orderBy('unit_name')
        .getRawMany();

      if (unitEntities && unitEntities.length) {
        return new PlantsDropDownResponse(true, 1111, 'Plants Retrieved Successfully', unitEntities);
      }
    } catch (error) {
      return error
    }

  }
  async getAllSubContractorPlants(): Promise<PlantsDropDownResponse> {
    try {
      const unitEntities: PlantsDropDown[] = await this.unitcodesRepository.createQueryBuilder()
        .select('unit_code_id as plantId, unit_name as plantName')
        .where(`plant_type = '${UnitTypeEnum.SUB_CONTRACTOR_PLANT}' and is_active=1 and unit_name!='Head Office'`)
        .orderBy('unit_name')
        .getRawMany();

      if (unitEntities && unitEntities.length) {
        return new PlantsDropDownResponse(true, 1111, 'Plants Retrieved Successfully', unitEntities);
      }
    } catch (error) {
      return error
    }

  }
  async getAllMainAndHoPlants(): Promise<PlantsDropDownResponse> {
    try {
      const unitEntities: PlantsDropDown[] = await this.unitcodesRepository.createQueryBuilder()
        .select('unit_code_id as plantId, unit_name as plantName')
        .where(`plant_type in ('${UnitTypeEnum.PLANT}','${UnitTypeEnum.HO}','${UnitTypeEnum.SUB_CONTRACTOR_PLANT}') and is_active=1`)
        .orderBy('unit_name')
        .getRawMany();

      if (unitEntities && unitEntities.length) {
        return new PlantsDropDownResponse(true, 1111, 'Plants Retrieved Successfully', unitEntities);
      }
    } catch (error) {
      return error
    }

  }
  async getAllSubPlants(): Promise<PlantsDropDownResponse> {
    try {
      const unitEntities: PlantsDropDown[] = await this.unitcodesRepository.createQueryBuilder()
        .select('unit_code_id as plantId, unit_name as plantName')
        .where(`plant_type='${UnitTypeEnum.SUB_PLANT}' and is_active=1`)
        .orderBy('unit_name')
        .getRawMany();
      if (unitEntities && unitEntities.length) {
        return new PlantsDropDownResponse(true, 1111, 'Sub Plants Retrieved Successfully', unitEntities);
      }
    } catch (error) {
      return error
    }

  }

  async getAllPlants(): Promise<PlantsDropDownResponse> {
    try {
      const unitEntities: PlantsDropDown[] = await this.unitcodesRepository.createQueryBuilder()
        .select('unit_code_id as plantId, unit_name as plantName, plant_type as plantType, plant_code as plantCode')
        .where(`is_active=1 and plant_type != '${UnitTypeEnum.MANUFACTURING_PLANT}'`)
        .orderBy('unit_name')
        .getRawMany();
      if (unitEntities && unitEntities.length) {
        const resp = new PlantsDropDownResponse(true, 1111, 'Plants Retrieved Successfully', unitEntities);
        // const newLogDto = new LogsDto(1,'view', 'AllPlants', 0, true, '','','','')
        //     let res = await this.logService.createLog(newLogDto);
        //     console.log(res);
        return resp
      }
    } catch (error) {
      return error
    }

  }

  async getAllManufacturingPlants(): Promise<PlantsDropDownResponse> {
    try {
      const unitEntities: PlantsDropDown[] = await this.unitcodesRepository.createQueryBuilder()
        .select('unit_code_id as plantId, unit_name as plantName,company')
        .where(`plant_type='${UnitTypeEnum.MANUFACTURING_PLANT}' and is_active=1 and unit_name!='Head Office'`)
        .orderBy('unit_name')
        .getRawMany();

      if (unitEntities && unitEntities.length) {
        const resu = new PlantsDropDownResponse(true, 1111, 'Plants Retrieved Successfully', unitEntities);
        // const newLogDto = new LogsDto(1,'view all plants', 'UnitCodes', 0, true, '','','','')
        //     let res = await this.logService.createLog(newLogDto);
        //     console.log(res);
        return resu
      }
    } catch (error) {
      return error
    }

  }



}